const angular = require('angular');
const app = angular.module('learn-directives');
var dragula = require('../../../node_modules/dragula/dragula');

/**
 * Defines the Explore order Directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('exploreOrder', ['Application', 'explorer', 'Categories', '$translate', function (Application, explorer, Categories, $translate) {
  return {
    restrict: 'E',
    scope: {
      active: '=',
      chosenCategory: '='
    },
    template: require('../../templates/directives/explore-order.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.emptyMeta = {};
      self.columnCount = 4;
      self.translations = [];

      self.isListView = Application.features.flags().explore_in_list_view;
      self.data = {
        loading: false,
        content: [],
        order: [],
        orderedIds: {},
        rows: [],
        reset: function() {
          this.content = [];
          this.order = [];
          this.orderedIds = {};
          this.rows = [];
        },
        load: function() {
          this.reset();
          self.progress.category = $scope.chosenCategory;
          this.loading = true;
          explorer.ordering({category: $scope.chosenCategory._id}).$promise
          .then(function(results) {
            self.data.order = results.order || [];
            self.data.content = results.data;
            self.data.setOrder();
            self.data.loading = false;
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['explore.order.error_retrieving']});
          });
        },
        setOrder: function() {
          var orderedItems = [];
          var unorderedItems = [];
          self.data.rows = [];

          for (var i = 0; i < self.data.content.length; i++) {
            var index = self.data.order.indexOf(self.data.content[i]._id);
            if (self.data.content[i].type === 'track' && self.data.content[i].resource) {
              self.data.content[i].type = 'resource';
            }
            if (index !== -1) {
              self.data.orderedIds[self.data.content[i]._id] = true;
              self.data.content[i].position = index;
              orderedItems.push(self.data.content[i]);
              continue;
            }
            unorderedItems.push(self.data.content[i]);
          }

          orderedItems.sort(function(a, b) {
            return a.position - b.position;
          });

          unorderedItems.sort(function(a, b) {
            return new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf();
          });

          orderedItems = orderedItems.concat(unorderedItems);

          var firstRowSet = false;
          while (orderedItems.length) {
            if (!self.isListView && (!firstRowSet && self.columnCount > 1)) {
              var firstRowColumns = self.isListView ? self.columnCount : self.columnCount - 1;
              self.data.rows.push(orderedItems.splice(0, firstRowColumns));
              firstRowSet = true;
              continue;
            }
            self.data.rows.push(orderedItems.splice(0, self.columnCount));
          }

          setTimeout(function() {
            self.setDrake();
          }, 10)
        }
      };

      self.progress = {
        category: null,
        unsaved: false,
        save: function() {
          var lastSaved;
          var list = [];
          for (var i = 0; i < container.children.length; i++) {
            for (var j = 0; j < container.children[i].children.length; j++) {
              var item = container.children[i].children[j];
              list.push(item.dataset.tile);
              lastSaved = self.data.orderedIds[item.dataset.tile] ? item.dataset.tile : lastSaved;
            }
          }

          if (!lastSaved) {
            // error no order created
            return;
          }

          var lastIndex = list.indexOf(lastSaved);
          if (!lastIndex && lastIndex !== 0) {
            // error
            return;
          }
          var orderedList = list.slice(0, lastIndex + 1);
          Categories.update({subresource: $scope.chosenCategory._id, fields: 'order'}, {order: orderedList}).$promise
          .then(function(category) {
            self.data.order = category.order;
            self.data.setOrder();
            Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['explore.order.order_saved']});
            self.progress.unsaved = false;
            $scope.active = 'content';
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['explore.order.error_saving']});
          });
        },
        cancel: function() {
          $scope.chosenCategory = self.progress.category;
          self.confirmUnsaved = false;
        },
        confirm: function() {
          self.data.load();
          self.confirmUnsaved = false;
        }
      };

      var container = document.getElementById('drag-container');
      self.setDrake = function() {
        var containers = [];
        var selected = document.querySelectorAll('#bag-one');
        for (var i = 0; i < selected.length; i++) {
          containers.push(selected[i]);
        }
        dragula(containers, {direction: 'horizontal'})
        .on('drop', function(el, target, source, sibling) {
          self.data.orderedIds[el.dataset.tile] = true;
          var short = -1;
          var long = -1;

          for(var i = 0; i < container.children.length; i++) {
            // Rules are different for the first row due to the featured card dropping it one less than other rows (unless there is a single item per row)
            if (i === 0 && self.columnCount > 1 && !self.isListView) {
              if (short === -1 && container.children[i].children.length < self.columnCount - 1) {
                short = i;
              }
              if (long === -1 && container.children[i].children.length > self.columnCount - 1) {
                long = i;
              }
              continue;
            }
            if (short === -1 && container.children[i].children.length < self.columnCount) {
              short = i;
            }
            if (long === -1 && container.children[i].children.length > self.columnCount) {
              long = i;
            }
          };

          self.progress.unsaved = true;
          if (long === -1) {
            return;
          }

          if (long > short) {
            var childRemoved = container.children[long].removeChild(container.children[long].children[0]);
            container.children[short].appendChild(childRemoved);
            return;
           }
           var childRemoved = container.children[long].removeChild(container.children[long].children[container.children[long].children.length - 1]);
           container.children[short].insertBefore(childRemoved, container.children[short].children[0]);
        });
        $scope.$apply();
      };

      $scope.$watch('chosenCategory', function (newValue, oldValue) {
        if ($scope.active === 'order' && newValue && newValue !== oldValue && newValue._id && newValue._id) {
          if (self.progress.category && self.progress.category._id === newValue._id) {
            return;
          }

          if (self.progress.unsaved) {
            self.confirmUnsaved = true;
            return;
          }
          self.data.load();
        }
      });

      $scope.$watch('active', function (newValue, oldValue) {
        if (newValue === 'order' && newValue !== oldValue) {
          self.data.load();
        }
      });

      if ($scope.active === 'order' && $scope.chosenCategory && $scope.chosenCategory._id) {
        self.data.load();
      }

      $translate([
        'explore.order.error_retrieving',
        'explore.order.order_saved',
        'explore.order.error_saving'
      ]).then(function (translations) {
        self.translations = translations;
      })

    }],
    controllerAs: 'order'
  };
}]);